module.exports = __webpack_public_path__ + "static/28-271de82add0ede22c476066401ca80e9.jpg";